import type { State } from '../index';
import * as MutationTypes from './mutationTypes';

export const titleMutations = {
  /** セッター： state.title.icon */
  [MutationTypes.SET_TITLE_ICON]: (state: State, icon: string) => {
    state.title.icon = icon;
  },
  /** セッター： state.title.main */
  [MutationTypes.SET_MAIN_TITLE]: (state: State, main: string) => {
    state.title.main = main;
  },
};
